import React from 'react';

import {Section} from '../containers';
import {Info, SkillCrtl, SkillSlider} from '../elements';

const Skill = ({api, translate}) => {
	const {info, data} = api.getSkill();
	return (
		<Section id="skill" className="padd-tb-60 grey lighten-5 skill-wrap">
			<div className="row">
				<div className="col s12">
					<Info {...info} translate={translate}/>
				</div>
			</div>
			<div className="row">
				<div className="clearfix skill-inner">
					<div className="col s12 m11">
						<SkillSlider className="skill-right" data={data}/>
					</div>
				</div>
			</div>
			<SkillCrtl/>
		</Section>
	);
};

export default Skill;



// WEBPACK FOOTER //
// ./src/components/sections/Skill.js